module.exports = __webpack_public_path__ + "media/assets/icons/tesuryo-icon-df48f2fe4fdd8d3154977c861d73765b.svg";